module.exports = __webpack_public_path__ + "img/btres_logo.c87005fe.png";